export default __webpack_public_path__ + "static/media/facility-management-en.512006a1.png";